const joinClassNames = (...parts) => parts.filter(Boolean).join(' ')

export default function EmptyState({ title = 'Nothing to show', message = '', action = null, className = '' }) {
  return (
    <article className={joinClassNames('gg-empty', className)}>
      <h3 className="gg-empty__title">{title}</h3>
      <p className="gg-empty__message">{message}</p>
      {action ? <div className="gg-empty__action">{action}</div> : null}
    </article>
  )
}
